export { default as Email} from './Email.svelte';
export { default as Facebook } from './Facebook.svelte';
export { default as HackerNews } from './HackerNews.svelte';
export { default as LinkedIn } from './LinkedIn.svelte';
export { default as Pinterest } from './Pinterest.svelte';
export { default as Reddit } from './Reddit.svelte';
export { default as Telegram } from './Telegram.svelte';
export { default as Tumblr } from './Tumblr.svelte';
export { default as Twitter } from './Twitter.svelte';
export { default as Vk } from './Vk.svelte';
export { default as WhatsApp } from './WhatsApp.svelte';
export { default as Xing } from './Xing.svelte';
